module.exports = __webpack_public_path__ + "media/images/back-arrow-af3639a0dc3ae7b6235d89cb3815a706.svg";